enum TransactionTag {
  None = 'none',
  Tourism = 'tourism',
  Drink = 'drink',
  Food = 'food',
  Transport = 'transport',
  Housing = 'housing',
  Shopping = 'shopping',
  Gift = 'gift',
  Entertainment = 'entertainment',
  Tax = 'tax'
}

export default TransactionTag

export interface ITagLabel {
  label: string
  icon: string
}
interface ITagAllLabel {
  [key: string]: ITagLabel
}
export const TransactionTagLabel: ITagAllLabel = {
  [TransactionTag.None]: {
    label: 'Aucune',
    icon: 'circle'
  },
  [TransactionTag.Tourism]: {
    label: 'Tourisme',
    icon: 'torii-gate'
  },
  [TransactionTag.Drink]: {
    label: 'Boisson',
    icon: 'beer'
  },
  [TransactionTag.Food]: {
    label: 'Restaurant',
    icon: 'utensils'
  },
  [TransactionTag.Transport]: {
    label: 'Transport',
    icon: 'subway'
  },
  [TransactionTag.Housing]: {
    label: 'Logement',
    icon: 'home'
  },
  [TransactionTag.Shopping]: {
    label: 'Courses',
    icon: 'shopping-basket'
  },
  [TransactionTag.Gift]: {
    label: 'Cadeau',
    icon: 'gift'
  },
  [TransactionTag.Entertainment]: {
    label: 'Divertissement',
    icon: 'theater-masks'
  },
  [TransactionTag.Tax]: {
    label: 'Impôt',
    icon: 'hand-holding-usd'
  }
}
